import { render, staticRenderFns } from "./AddVoucherType.vue?vue&type=template&id=b5f97070"
import script from "./AddVoucherType.vue?vue&type=script&lang=js"
export * from "./AddVoucherType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports